// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// 解决浏览器兼容
import "babel-polyfill"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// layout 布局
import headerFooter from './layouts/header-footer'
// import hAsideF from './layouts/h-aside-f'

import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css';


Vue.use(ElementUI)
Vue.component('header-footer',headerFooter)
// Vue.component('h-aside-f',hAsideF)


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  document.title = `北京奥信汽车服务有限公司`;
  // document.title = `福保保险经纪 | ${to.meta.title} `;
  next();
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js